import { useState, useEffect } from 'react';
import { Modal, Stack, Text, Button, Group } from '@mantine/core';

const STORAGE_KEY = 'kian.v2.onboarded';

export interface KianOnboardingTourProps {
  /** Flyout gerade sichtbar */
  flyoutOpen: boolean;
}

export function KianOnboardingTour({ flyoutOpen }: KianOnboardingTourProps) {
  const [step, setStep] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!flyoutOpen) return;
    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch {
      return;
    }
    setModalOpen(true);
  }, [flyoutOpen]);

  if (!modalOpen) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
    setModalOpen(false);
  };

  const titles = ['KIAN-FAB', 'Schnellzugriff', 'Kontext anheften'];
  const bodies = [
    'Unten rechts öffnest du KIAN jederzeit – der Chat bleibt beim Seitenwechsel erhalten.',
    'Mit ⌘K (Mac) bzw. Strg+K (Windows) öffnest oder schließt du das Panel schnell.',
    'Mit dem Pin-Symbol frierst du den Kontext ein: KIAN bleibt beim gewählten Ticket, auch wenn du woanders navigierst.',
  ];

  return (
    <Modal opened={step < 3} onClose={dismiss} title={titles[step] ?? ''} size="sm" centered>
      <Stack gap="md">
        <Text size="sm">{bodies[step]}</Text>
        <Group justify="flex-end">
          <Button variant="subtle" onClick={dismiss}>
            Überspringen
          </Button>
          {step < 2 ? (
            <Button
              onClick={() => {
                setStep((s) => s + 1);
              }}
            >
              Weiter
            </Button>
          ) : (
            <Button
              onClick={() => {
                dismiss();
              }}
            >
              Verstanden
            </Button>
          )}
        </Group>
      </Stack>
    </Modal>
  );
}
